import styled from 'styled-components';
import {} from './index.js';
import { getMargins } from '@oneaudi/unified-web-common';
export const StyledSVG = styled.svg `
  // TODO: is this the final color? because with inherit, theming will only work if a parent defines a color
  color: inherit;
  margin: ${(props) => getMargins(props.margin)};
`;
//# sourceMappingURL=index.styles.js.map